import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BrowsingDatapoint } from '@models/browsingDatapoint.model';
import { environment } from '../../../environments/environment';

@Injectable()
export class BrowsingDatapointsService {
  baseHref = `${environment.apiUrl}/browsing_datapoints`;

  constructor(private http: HttpClient) {}

  logUserInput(data: BrowsingDatapoint): Observable<any> {
    const postUrl = `${this.baseHref}`;
    return this.http.post<BrowsingDatapoint>(postUrl, data);
  }
}
